import { PublicClientApplication } from '@azure/msal-browser';

const MSAL_CONFIG = {
  auth: {
    clientId: 'b726bf66-54cf-4c5e-bdb3-235af682f2cf',
    authority: 'https://login.microsoftonline.com/a22735e9-c18f-468e-8b2e-25998df22bfa',
    redirectUri: `${process.env.VUE_APP_BASE_URL}submission-review`,
    postLogoutRedirectUri: process.env.VUE_APP_BASE_URL,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
};

const LOGIN_REQUEST = {
  scopes: ['openid', 'offline_access'],
};

const TOKEN_REQUEST = {
  scopes: ['b726bf66-54cf-4c5e-bdb3-235af682f2cf/.default'],
};

const GRAPH_CONFIG = {
  graphUsersEndpoint: 'https://graph.microsoft.com/v1.0/users',
};

const PUBLIC_CLIENT_APPLICATION = new PublicClientApplication(MSAL_CONFIG);

export {
  MSAL_CONFIG,
  LOGIN_REQUEST,
  TOKEN_REQUEST,
  GRAPH_CONFIG,
  PUBLIC_CLIENT_APPLICATION,
};
